export const BusinessProfileAutocompleteStyles = {
  autoCompleteSx: {
    '& .MuiInputBase-root': {
      borderRadius: '6px',
      maxHeight: '44px',
      paddingTop: '3px'
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '6px',
      padding: '4px 8px',
      fontSize: 'var(--font-size-14)',
    },
    '& input::placeholder': {
      opacity: 1,
      fontSize: 'var(--font-size-14)',
    }
  },
  textFieldSx: {
    '& input::placeholder': {
      fontSize: 'var(--font-size-16)',
      marginLeft: '-1px',
      opacity: 1
    }
  },
  listItem: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingY: 1,
    paddingX: 2,
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%'
  },
  name: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    width: '100%',
    color: 'var(--color-text-heading)'
  },
  address: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    marginTop: '2px',
    textAlign: 'left',
    color: 'var(--color-text-heading)',
    width: '100%'
  }
};

